export default __webpack_public_path__ + "locales/hy-AM/DeleteDialog.json?hash=348bf529818dc271c98d39d9b2d52c71";